/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_App_Allow_ListInputs */

const en_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom App Allow List`)
};

const ar_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق مخصص قائمة السماح`)
};

const de_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte App Liste zulassen`)
};

const es_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista personalizada de apps permitidas`)
};

const fr_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des autorisations personnalisée`)
};

const it_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista App Consentite personalizzata`)
};

const ja_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリの許可リストのカスタマイズ`)
};

const ko_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커스텀 앱 앱 허용 리스트`)
};

const pt_br_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de permissões personalizada`)
};

const ru_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настраиваемый Список разрешений приложений`)
};

const th_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการอนุญาตแอปที่กำหนดเอง`)
};

const tr_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel Uygulama İzin Listesi`)
};

const zh_cn_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自订软件白名单`)
};

const zh_tw_custom_app_allow_list = /** @type {(inputs: Custom_App_Allow_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自訂 App 允許名單`)
};

/**
* | output |
* | --- |
* | "Custom App Allow List" |
*
* @param {Custom_App_Allow_ListInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const custom_app_allow_list = /** @type {((inputs?: Custom_App_Allow_ListInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_App_Allow_ListInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_custom_app_allow_list(inputs)
	if (locale === "ar") return ar_custom_app_allow_list(inputs)
	if (locale === "de") return de_custom_app_allow_list(inputs)
	if (locale === "es") return es_custom_app_allow_list(inputs)
	if (locale === "fr") return fr_custom_app_allow_list(inputs)
	if (locale === "it") return it_custom_app_allow_list(inputs)
	if (locale === "ja") return ja_custom_app_allow_list(inputs)
	if (locale === "ko") return ko_custom_app_allow_list(inputs)
	if (locale === "pt_br") return pt_br_custom_app_allow_list(inputs)
	if (locale === "ru") return ru_custom_app_allow_list(inputs)
	if (locale === "th") return th_custom_app_allow_list(inputs)
	if (locale === "tr") return tr_custom_app_allow_list(inputs)
	if (locale === "zh_cn") return zh_cn_custom_app_allow_list(inputs)
	return zh_tw_custom_app_allow_list(inputs)
});